import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import copy from 'copy-to-clipboard';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import AddTeamDialog from './addTeamDialog';
import RenameTeam from './renameTeam';
import DeleteDialog from '../../portal/dialogs/deleteDialog';
import ErrorDialog from '../../portal/dialogs/errorDialog';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';

@inject('translationsStore', 'teamsStore', 'teamMembersStore', 'oidcStore') @observer
export default class TeamManageMenu extends Component {

    state = {
        openContextMenu: false,
        openAddDialog: false,
        openEditDialog: false,
        openDeleteTeamDialog: false,
        openErrorDialog: false
    };

    openEditMenu = (event) => {

      event.preventDefault();
  
      this.setState({
        openContextMenu: true,
        anchorEl: event.currentTarget
      });
    }

    closeContextMenu = () => {
        
        this.setState({
            openContextMenu: false
        });
    }

    focusInput = () => {


        setTimeout(() => {
            
            const elem = document.querySelector('.portal-textbox input');

            elem ? elem.focus() : null;

        }, 500);
    }

    openAddDialog = () => {

        this.setState({ 
            openAddDialog: true
        });

        this.focusInput();

        this.closeContextMenu();
    }

    closeAddDialog = (e) => {
        this.props.teamsStore.setTeamName('');
        
        this.setState({ 
            openAddDialog: false
        });
    }

    openEditDialog = () => {

        this.setState({ 
            openEditDialog: true
        });

        const t = this.props.teamsStore.selectedTeam;

        this.props.teamsStore.setEditTeamName(t.name);

        this.focusInput();

        this.closeContextMenu();
    }

    closeEditDialog = (e) => {
        this.setState({ 
            openEditDialog: false
        });
    }

    addOrganiztion = (e) => {

        e.preventDefault();

        this.props.teamsStore.addTeam().then(() => {

            this.closeAddDialog();
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.props.translationsStore.translate('TEAM_CREATED_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({level, message});
        })
        .catch(() => {
                
            this.closeAddDialog();
            this.openErrorDialog();
        });
    }

    handleUpdateTeamError = () => {

        this.closeEditDialog();
        this.openErrorDialog();
    }

    getAllTeamsAfterUpdate = () => {

        this.props.teamsStore.getAllTeams()
        .then(() => {

            this.closeEditDialog();
        })
        .catch(() => {
        
            this.handleUpdateTeamError();
        })
        .finally(() => {

            this.props.teamsStore.updatingTeam = false;
        });  
    }

    updateTeam = (e) => {

        e.preventDefault();

        this.props.teamsStore.updateTeam(
            this.props.teamsStore.selectedTeamId, 
            this.props.teamsStore.editTeamName, 
            this.props.teamsStore.selectedTeam.parentId)           
        .then(() => {

            this.props.teamsStore.updatingTeam = true;

            if(this.props.teamsStore.selectedTeam.parentId === 0){

                this.props.oidcStore.startSilentRenew()
                .finally(() => {

                    this.getAllTeamsAfterUpdate();
                });  
            }else{

                this.getAllTeamsAfterUpdate();
            }                  
        })
        .catch(() => {
                
            this.handleUpdateTeamError();
        });  
    }

    deleteTeam = () => {

        this.props.teamsStore.deleteTeam().then(() => {

            this.closeDeleteTeamDialog();

            const level = ToastrLevelsEnum.SUCCESS;
            const message = this.props.translationsStore.translate('TEAM_DELETED_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({level, message});

            const teams = this.props.teamsStore.teams;

            if(teams && teams.length > 0) {

                const teamId = this.props.teamsStore.selectedTeamParentId;
                    
                this.props.teamsStore.setSelectedTeamId(teamId);
                this.props.teamsStore.setTeamIds([`${teamId}`]);
                this.props.teamMembersStore.getTeamUsers(teamId);
            }
        })
        .catch(() => {
                
            this.closeDeleteTeamDialog();
            this.openErrorDialog();
        });
    }

    openDeleteTeamDialog = () => {

        this.closeContextMenu();

        this.setState({
            openDeleteTeamDialog: true
        });
    }

    closeDeleteTeamDialog = () => {

        this.setState({
            openDeleteTeamDialog: false
        });
    }

    openErrorDialog = () => {

        this.setState({ 
            openErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            openErrorDialog: false
        }); 
    }

    copyTeamPathToClipboard = () => {

        copy(this.props.teamsStore.selectedTeam.fullName);

        var level = ToastrLevelsEnum.SUCCESS;
        
        var message = this.props.translationsStore.translate('COPIED_TEAM_NAME_TO_CLIPBOARD');
        
        ToastrService.triggerToastr({level, message});
    
        this.closeContextMenu();
    }

    handleAddTeamOnChange = e => this.props.teamsStore.setTeamName(e.target.value);
    handleEditTeamOnChange = e => this.props.teamsStore.setEditTeamName(e.target.value);

    render(){

        const translationsStore = this.props.translationsStore;

        const deleteDialogMessage =
           <div>
               {this.props.translationsStore.translate('CONFIRM_DELETE_TEAM')
                                            .replace('{teamName}', this.props.teamsStore.selectedTeamName)}
               <br />
               {this.props.translationsStore.translate('LDAP_TEAM_MAPPINGS_WILL_BE_REMOVED')}
           </div>;

        return(
            <div className='teams-menu-button-wrapper'>
                <RaisedButton
                    onClick={this.openEditMenu}
                    className='grid-context-menu-button'
                    icon={<span className='menu-icon icon-button'></span>}
                    disabled={this.props.disableTeamMenu}
                    data-cy='teams-menu-button'
                />
                <Popover
                    className='edit-context-menu edit-team'
                    style={{
                        fontSize: '15px'
                    }}
                    open={this.state.openContextMenu}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}
                    onRequestClose={this.closeContextMenu}>
                    <Menu>
                        <MenuItem
                            onClick={this.openAddDialog}
                            children={<div data-cy='add-team-option'>{translationsStore.translate('ADD_TEAM')}</div>}
                        />
                        <MenuItem
                            onClick={this.openEditDialog}
                            children={<div data-cy='rename-team-option'>{translationsStore.translate('RENAME_TEAM')}</div>}
                        />
                        <MenuItem
                            onClick={this.openDeleteTeamDialog}
                            children={<div data-cy='delete-team-option'>{translationsStore.translate('DELETE_TEAM')}</div>}
                        />
                        <MenuItem
                            onClick={this.copyTeamPathToClipboard}
                            children={<div data-cy='copy-team-path-option'>{translationsStore.translate('COPY_FULL_TEAM_PATH')}</div>}
                        />
                    </Menu>
                </Popover>
                <AddTeamDialog 
                    open={this.state.openAddDialog} 
                    onCancel={this.closeAddDialog}
                    onSave={this.addOrganiztion}
                    onChange={this.handleAddTeamOnChange}
                    teamName={this.props.teamsStore.teamName}
                    inProgress={this.props.teamsStore.creatingTeam}
                 />
                <RenameTeam 
                    open={this.state.openEditDialog} 
                    onCancel={this.closeEditDialog}
                    onSave={this.updateTeam}
                    onChange={this.handleEditTeamOnChange}
                    teamName={this.props.teamsStore.editTeamName}
                    inProgress={this.props.teamsStore.updatingTeam}
                />
                <DeleteDialog 
                    show={this.state.openDeleteTeamDialog}
                    dialogDataCy='delete-team-confirmation-alert'
                    dataCy='delete-team-button'
                    deleteButtonText={this.props.translationsStore.translate('DELETE')}                                
                    cancelText={this.props.translationsStore.translate('CANCEL')}                                
                    onConfirm={this.deleteTeam}
                    closeDeleteDialog={this.closeDeleteTeamDialog}
                    titleText={this.props.translationsStore.translate('DELETE_TEAM') + '?'}
                    contentText={deleteDialogMessage} 
                    inProgress={this.props.teamsStore.deletingTeam}
                />
                <ErrorDialog 
                    show={this.state.openErrorDialog}
                    dataCy='add-team-error-alert'
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.props.translationsStore.translate('ERROR')}
                    contentText={this.props.teamsStore.teamErrorMessage} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/teamManageMenu/index.jsx